export const employeeConstants = {
  CREATE_EMPLOYEE: "CREATE_EMPLOYEE",
  UPDATE_EMPLOYEE: "UPDATE_EMPLOYEE",
  GET_EMPLOYEES: "GET_EMPLOYEES",
  GET_EMPLOYEE_BY_ID: "GET_EMPLOYEE_BY_ID",
  DELETE_EMPLOYEE: "DELETE_EMPLOYEE",
  GET_EMPLOYEES_LIST: "GET_EMPLOYEES_LIST",
  GET_DASHBOARD_STATS : "GET_DASHBOARD_STATS",
  GET_EMPLOYEES_Attendance_By_Id:"GET_EMPLOYEES_Attendance_By_Id",
  EMPLOYEES_CHECK_OUT:"EMPLOYEES_CHECK_OUT",
  EMPLOYEES_CHECK_IN:"EMPLOYEES_CHECK_IN",
  GET_ALL_EMPLOYEES_ATTENDANCE: "GET_ALL_EMPLOYEES_ATTENDANCE",
  EMPLOYEE_SESSIONS:"EMPLOYEE_SESSIONS",
  EMPLOYEE_SESSION_FORM_DATA: "EMPLOYEE_SESSION_FORM_DATA",
  EMPLOYEE_USER_ID: "EMPLOYEE_USER_ID",
  EMPLOYEE_ID: "EMPLOYEE_ID"
};
